import React, { ReactElement } from 'react';
import 'src/common/style/common.scss';

export interface FootnoteProps {
  numNote: number;
}

export default function Footnote({ numNote }: FootnoteProps): ReactElement {
  return (
    <p className="footnote_num">
      <span>{numNote}</span>
    </p>
  );
}
